export enum AssetState {
  INITIAL = 'INITIAL',
  IDENTIFIED = 'IDENTIFIED',
  REGISTERED = 'REGISTERED',
  INGESTED = 'INGESTED',
  ERROR = 'ERROR'
}

/** File type identifier; values come from identification rules (see config.fileTypes). */
export type FileType = string;

export type AssetEvent =
  | { type?: 'STATE_CHANGE'; state: AssetState; date: number; description?: string }
  | { type: 'ACTION_TRIGGERED'; actionType: string; actionId: string; date: number };

export interface Asset {
  id: string;
  assetId: string;
  sourceUri: string;
  fileType: FileType;
  state: AssetState;
  storageType: 'S3';
  size: number;
  receivedOn: number;
  locationAddress: string;
  locationPath: string;
  stagedCopy?: string;
  stagedCopyKey?: string;
  events: AssetEvent[];
}

export interface DashboardStats {
  totalAssets: number;
  receivedToday: number;
  activeProcessing: number;
  failedAssets: number;
}
